<template>
  <div class="hero-text" :class="$store.state.brand.name">
    <div class="hero-header" :class="$store.state.brand.name">{{ heading }}</div>
    <p :class="$store.state.brand.name">{{ subHeading}}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HeroOverlay',
  props: {
    heading: String,
    subHeading: String
  }
}
</script>

<style scoped>
/* styles for xs screens go here */
.hero-text {
  text-align: left;
  position: absolute;
  bottom: 10%;
  left: 15%;
  height: fit-content;
  width: 70%;
  color: #ffffff;
  z-index: 2;
}
.hero-text.ford,
.hero-text.mercedes-benz {
  top: 10%;
}
.hero-text.lincoln {
  top: 25%;
}
.hero-text.toyota {
  bottom: 25%;
}
.hero-text.infiniti,
.hero-text.honda {
  text-align: center;
}
.hero-text.mazda,
.hero-text.lexus {
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.078125em;
}
.hero-text.kia {
  text-align: center;
  letter-spacing: 0.078125em;
}
.hero-text.porsche,
.hero-text.lincoln,
.hero-text.ford,
.hero-text.subaru,
.hero-text.mitsubishi {
  letter-spacing: 0.078125em;
}
.hero-header {
  margin-top: 8px;
  margin-bottom: 8px;
  height: fit-content;
  --default-max-hero-header-font-size: 46;
  font-family: var(--title-font-stack);
  /* calculated responsive font-size: calc([minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width]))); */
  font-size: calc(30px + (var(--default-max-hero-header-font-size) - 30) * ((100vw - 300px) / (1600 - 300)));
  line-height: 1.05em;
  color: var(--hero-header-text-color);
}
.hero-header.mitsubishi,
.hero-header.bmw,
.hero-header.mini,
.hero-header.cadillac {
  text-transform: uppercase;
}
.hero-header.infiniti {
  --default-max-hero-header-font-size: 24;
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
}
.hero-header.lexus {
  padding-bottom: 0.625em;
  border-bottom: solid 3px #ffffff;
  display: inline-block;
}
p {
  margin-top: 0em;
  margin-bottom: 1em;
  font-size: 1em;
  line-height: 1.05em;
}
p.porsche {
  font-weight: bold;
}
/* styles for different screen widths follow */
@media only screen and (min-width: 576px) {
  .hero-text {
    left: 10%;
    width: 75%;
  }
}
@media only screen and (min-width: 768px) {
  p {
    font-size: 20px;
  }
}
@media only screen and (min-width: 992px) {
}
@media only screen and (min-width: 1200px) {
}
</style>
